import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bg-color1",
  "use": "icon-bg-color1-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bg-color1\">\n<rect y=\"0.019043\" width=\"24\" height=\"24\" rx=\"2\" fill=\"#FFDCB0\" />\n<path d=\"M10.822 7.02304L7 17.019H8.75L9.66 14.513H13.846L14.756 17.019H16.506L12.684 7.02304H10.822ZM10.15 13.169L11.732 8.78704H11.788L13.356 13.169H10.15Z\" fill=\"#464646\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol